import {
  AdvancedMarker,
} from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useState } from "react";
import { fromAddress } from "react-geocode";
import "./GoogleMapMarker.css";
import { API_URL } from "../../actions/settings";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
// eslint-disable-next-line
import smartSheetIcon from "../../AE2/static/icons/smartsheet-icon.svg";
import { Building } from "../../interfaces/Building";
import type {Marker} from '@googlemaps/markerclusterer';



interface Props {
  building: Building;
  Address: String;
  onClick: (b:any)=>void;
  setMarkerRef: (marker: Marker | null, key: string) => void;
}

async function saveCords(token: string, data: any, id: string) {
  return fetch(`${API_URL}/buildings/${id}/coordinates`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(data),
  }).then((data) => data.json());
}

const getCords = async (
  Address: String,
  setCords: any,
  handleSaveCords: any
) => {
  fromAddress(String(Address))
    .then(({ results }) => {
      const { lat, lng } = results[0].geometry.location;
      setCords({ lat, lng });
      handleSaveCords(lat, lng);
    })
    .catch(console.error);
};

const GoogleMapMarkerV2: React.FC<Props> = ({ building, Address, onClick, setMarkerRef }) => {
  // eslint-disable-next-line
  const user = useAppSelector(selectUser);
  const [cords, setCords] = useState<any>(null);

  const handleSaveCords = useCallback(
    async (lat: any, lng: any) => {
      const token: any = localStorage.getItem("token");
      const res = await saveCords(
        `Token ${token.slice(1, -1)}`,
        { lat, lng },
        building.uuid
      );
      console.warn(res);
    },
    [building.uuid]
  );


  useEffect(() => {
    const handleCords = async () => {
      await getCords(Address, setCords, handleSaveCords);
    };
    if (!building.latitude && !building.longitude) {
      handleCords();
    } else {
      const lat = Number(building.latitude);
      const lng = Number(building.longitude);
      setCords({
        lat,
        lng,
      });
    }
  }, [Address, handleSaveCords, building.latitude, building.longitude]);

  const handleMarkerClick = useCallback(() => onClick(building), [onClick, building]);


  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) =>
      setMarkerRef(marker, building.uuid),
    [setMarkerRef, building.uuid]
  );

  if (cords) {
    return (
      <>
        <AdvancedMarker
          ref={ref}
          position={cords}
          onClick={handleMarkerClick}
          title={building.building_name}        
        >          
        </AdvancedMarker>
      </>
    );
  }
  return null;
};

export default GoogleMapMarkerV2;
